import React from "react";

const UnsupportedDevice = () => {
    return (
        <div
            className="min-h-screen flex flex-col justify-between bg-[#f9fafb] text-gray-800"
            style={{ zoom: 1.33 }}
        >
            <div className="flex-grow flex items-center justify-center px-4">
                <div className="w-full max-w-sm text-center bg-white shadow-md border border-gray-200 rounded-2xl p-6">
                    {/* Logo */}
                    <img
                        src="/header_crm_logo.webp"
                        alt="Swalook Logo"
                        className="h-45 w-auto mx-auto mb-1"
                    />

                    {/* Heading */}
                    <h1 className="text-2xl font-bold text-red-600">
                        Unsupported Device
                    </h1>

                    {/* Subheading */}
                    <p className="mt-3 text-sm text-gray-600">
                        This app is optimized for mobile phones only.
                    </p>

                    <p className="text-xs text-gray-400 mt-1">
                        Kindly access this application from your smartphone.
                    </p>
                </div>
            </div>

            {/* Footer Branding */}
            <div className="py-4 text-center text-xs text-gray-400">
                &copy; {new Date().getFullYear()} Swalook. All rights reserved.
            </div>
        </div>
    );
};

export default UnsupportedDevice;
